import { getTextWidth } from "../helper/getTextWidth";
import { CONNECTOR, IC } from "../PCBHelper";
import { select, event, selectAll } from 'd3-selection';
import { drag } from "d3-drag";
import { CLAMP_DIODE_COLOR, getColor, getTitle } from ".";
import { RLC, DIODE } from "../../constants/componentType";


class ElementsCanvas {
  constructor(props) {
    const { svgElement, width = 140, height, top, types = [IC, CONNECTOR, RLC], createElement, saveElement, updateElementLocation } = props;
    this.svgElement = svgElement;
    this.width = width;
    this.types = types || [];
    this.top = top || 0;
    //55 is rect height, 20 id rect padding top, this.top is content box top
    this.height = this.getHeight(height);
    this.createElement = createElement;
    this.saveElement = saveElement;
    this.updateElementLocation = updateElementLocation;
  }

  getHeight = (height) => {
    if (height) {
      return height;
    }

    const filterTypes = this.types.filter(it => it !== DIODE);
    let _height = filterTypes.length ? filterTypes.length * 55 + 20 + this.top : 200;

    if (this.types.includes(DIODE)) {
      _height = _height + 90
    }
    return _height;
  }

  clear = () => {
    /*   this.svgElement = null;
      this.width = 140;
      this.height = 200;
      this.types = [];
      this.createElement = null;
      this.saveElement = null;
      this.updateElementLocation = null; */
    select(this.svgElement).selectAll('*').remove();
  }

  draw = () => {
    if (!this.svgElement) {
      return
    }
    select(this.svgElement).selectAll('*').remove();
    this.root = select(this.svgElement);
    this.root.attr("width", this.width);
    this.root.attr("height", this.height);
    let initialX, initialY;
    let rectKey, rectColor;
    let newX, newY;
    const plot = this;
    this.rectDrag = drag().on("start", function () {

      const currElement = select(this);
      rectKey = currElement.attr("key");
      const element = select(`rect.rect-${rectKey}`);
      initialX = +element.attr("x");
      initialY = +element.attr("y");
      rectKey = element.attr("key");
      rectColor = element.attr("stroke");
      newX = NaN; newY = NaN;

      plot.dragRect = plot.root.append("rect")
        .attr("id", "drag-rect")
        .attr('x', initialX)
        .attr('y', initialY)
        .attr('width', 110)
        .attr('height', rectKey === DIODE ? 90 : 40)
        .attr('rx', 6)
        .attr('ry', 6)
        .attr('key', rectKey)
        .attr("fill", "none")
        .attr('opacity', 0.5)
        .attr("stroke", rectKey === DIODE ? "none" : rectColor)
        .attr("stroke-width", rectKey === DIODE ? 0 : 3)
      if (rectKey === DIODE) {
        plot.drawDiode(rectKey, { x: initialX, y: initialX });
      }
      plot.createElement({ key: rectKey, x: initialX, y: initialY })
    }).on("drag", function () {
      const dx = event.x - event.subject.x;
      newX = initialX + dx;

      const dy = event.y - event.subject.y;
      newY = initialY + dy;

      plot.dragRect
        .attr("x", newX)
        .attr("y", newY);
      plot.updateElementLocation({ key: rectKey, x: newX, y: newY })
      if (rectKey === DIODE) {
        plot.drawDiode(rectKey, { x: newX, y: newY });
      }
    }).on("end", () => {
      plot.saveElement({ key: rectKey, x: newX, y: newY });
      select("#drag-rect").remove();
      selectAll(".line-ele-diode-drag").remove();
    })
    let num = 0;
    for (let key of this.types || []) {
      //rect
      const color = getColor(key);
      const title = getTitle(key);
      const textWidth = getTextWidth(title, 14);
      this.root.append('rect')
        .attr("class", `rect-${key}`)
        .attr('x', 15)
        .attr('y', 20 + this.top + num * 55)
        .attr('width', 110)
        .attr('height', key === DIODE ? 90 : 40)
        .attr('rx', 6)
        .attr('ry', 6)
        .attr('key', key)
        .attr("fill", "none")
        .attr("stroke", key === DIODE ? "none" : color)
        .attr("stroke-width", key === DIODE ? 0 : 3)
        .attr("pointer-events", "all")
        .on("mouseover", function () {
          select(this).style("cursor", "pointer");
          /* if (key === DIODE) {
            plot.root.append("text")
              .attr("class", `text-${key}-title-tooltip`)
              .text("Diode")
              .attr("x", 68 - textWidth / 2)
              .attr("y", textY + 35)
          } */
        })
        .on("mouseout", function () {
          select(this).style("cursor", "");
    /*       selectAll(`text.text-${key}-title-tooltip`).remove() */
        })
        .call(this.rectDrag)

      if (key === DIODE) {
        this.drawDiode(key, { x: 15, y: 20 + this.top + num * 55 }, true);
      } /* else { */
      //text
      const textY = 20 + this.top + num * 55;

      this.root.append("text")
        .text(title)
        .attr("class", `text-${key}`)
        .attr('x', key === DIODE ? 65 : 68 - textWidth / 2)
        .attr('y', key === DIODE ? textY + 42 : textY + 24)
        .style("cursor", "pointer")
        .attr("font-weight", "500")
        .attr('key', key)
        .call(this.rectDrag)
      /* } */

      num += 1;
    }
  }

  drawDiode = (name, rectLocation, iCreate) => {
    const midX = rectLocation.x + 55;
    const className = iCreate ? "line-ele-diode" : "line-ele-diode-drag";
    // 40/25
    //Vertical Line
    const vLines = [
      { y: rectLocation.y },
      { y: rectLocation.y + 45 },
    ];
    let index = 0;
    for (let line of vLines) {
      let lineItem = this.root.select(`line.${className}-v-${index}`)
      if (lineItem.empty()) {
        lineItem = this.root.append("line")
          .attr("class", `${className}-v-${index} ${className}`)
      }

      lineItem
        .attr("x1", midX)
        .attr("y1", line.y)
        .attr("x2", midX)
        .attr("y2", line.y + 25)
        .attr("stroke", CLAMP_DIODE_COLOR)
        .attr("stroke-width", 2);
      index += 1;
    }

    //Horizontal line
    const hLine = { y: rectLocation.y + 25, length: 40 };
    let hLineItem = this.root.select(`line.${className}-h`)
    if (hLineItem.empty()) {
      hLineItem = this.root.append("line")
        .attr("class", `${className}-h ${className}`)
    }
    hLineItem
      .attr("x1", midX - 20)//hLine.length/2
      .attr("y1", hLine.y)
      .attr("x2", midX + 20)
      .attr("y2", hLine.y)
      .attr("stroke", CLAMP_DIODE_COLOR)
      .attr("stroke-width", 2);

    const triangles = [
      [midX, rectLocation.y + 25],
      [midX - 20, rectLocation.y + 45],
      [midX + 20, rectLocation.y + 45]
    ];

    let triItem = this.root.select(`polygon.${className}-polygon`)
    if (triItem.empty()) {
      triItem = this.root.append("polygon")
        .attr("class", `${className}-polygon ${className}`)
    }
    triItem
      .attr("points", generateTrianglePoints(triangles))
      .attr('fill', CLAMP_DIODE_COLOR)
      .attr("stroke", CLAMP_DIODE_COLOR)
      .attr("stroke-width", 2)
      .attr("key", name)
      .style("cursor", "pointer")
      .call(this.rectDrag);
  }

  drawGnd = (key, rectLocation) => {
    const color = getColor(key);
    const midX = rectLocation.x + 55;
    // 40/25
    this.root.append("line")
      .attr("x1", midX).attr("y1", rectLocation.y)
      .attr("x2", midX).attr("y2", rectLocation.y + 25)
      .attr("stroke", color)
      .attr("stroke-width", 2);

    const lines = [
      { y: rectLocation.y + 25, length: 50 },
      { y: rectLocation.y + 30, length: 30 },
      { y: rectLocation.y + 35, length: 10 }
    ];

    lines.forEach(line => {
      this.root.append("line")
        .attr("x1", midX - line.length / 2)
        .attr("y1", line.y)
        .attr("x2", midX + line.length / 2)
        .attr("y2", line.y)
        .attr("stroke", color)
        .attr("stroke-width", 2);
    });
  }
}

export function generateTrianglePoints(list) {
  return list.map(p => p.join(",")).join(" ");
}

export default ElementsCanvas;